/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const newOnUpdatedFieldInstance = /* GraphQL */ `
	subscription NewOnUpdatedFieldInstance($formGroup: ID!) {
		newOnUpdatedFieldInstance(formGroup: $formGroup) {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				tableField
				action
				csvKey
				identityRole
				rowOrder
				tableFields {
					nextToken
				}
				options {
					nextToken
				}
				optionsOrder
				docId
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				formInstance
				formGroup
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					csvKey
					identityRole
					optionsOrder
					docId
					group
					createdAt
					updatedAt
				}
				fieldTemplateId
				value
				altInstance {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder
					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				altInstanceId
				tableField
				fieldsOrder
				tableFields {
					nextToken
				}
				notes
				authors
				editing
				group
				createdAt
				updatedAt
			}
			altInstanceId
			tableField
			fieldsOrder
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder
					notes
					authors
					editing
					group
					imageId
					image {
						id
						key
						rotation
						dpi
						aspectX
						aspectY
						createdAt
						updatedAt
						formGroup
						project
						group
					}
					createdAt
					updatedAt
				}
				nextToken
			}
			forceUpdateData
			notes
			authors
			imageId
			image {
				id
				key
				rotation
				dpi
				aspectX
				aspectY
				createdAt
				updatedAt
				formGroup
				project
				group
			}
			editing
			group
			createdAt
			updatedAt
		}
	}
`;
export const newOnUpdatedFormGroup = /* GraphQL */ `
	subscription NewOnUpdatedFormGroup($id: ID!) {
		newOnUpdatedFormGroup(id: $id) {
			id
			users
			name
			type
			formOrder
			formInstances {
				items {
					id
					formTemplateId
					group
					formGroup
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;
export const newOnUpdatedProject = /* GraphQL */ `
	subscription NewOnUpdatedProject($id: ID!) {
		newOnUpdatedProject(id: $id) {
			id
			forceUpdateData
			users
			name
			group
			public
		}
	}
`;
export const onCreateFormTemplate = /* GraphQL */ `
	subscription OnCreateFormTemplate {
		onCreateFormTemplate {
			id
			template
			description
			fieldsOrder
			fieldTemplates {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					csvKey
					identityRole
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateFormTemplate = /* GraphQL */ `
	subscription OnUpdateFormTemplate {
		onUpdateFormTemplate {
			id
			template
			description
			fieldsOrder
			fieldTemplates {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					csvKey
					identityRole
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteFormTemplate = /* GraphQL */ `
	subscription OnDeleteFormTemplate {
		onDeleteFormTemplate {
			id
			template
			description
			fieldsOrder
			fieldTemplates {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					docId
					group
					csvKey
					identityRole
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onCreateFieldTemplate = /* GraphQL */ `
	subscription OnCreateFieldTemplate {
		onCreateFieldTemplate {
			id
			formTemplate
			inputType
			header
			tableField
			action
			rowOrder
			tableFields {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					docId
					group
					csvKey
					identityRole
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			options {
				items {
					id
					formTemplateId
					label
					value
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			optionsOrder
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateFieldTemplate = /* GraphQL */ `
	subscription OnUpdateFieldTemplate {
		onUpdateFieldTemplate {
			id
			formTemplate
			inputType
			header
			tableField
			action
			rowOrder
			tableFields {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					docId
					group
					csvKey
					identityRole
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			options {
				items {
					id
					formTemplateId
					label
					value
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			optionsOrder
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteFieldTemplate = /* GraphQL */ `
	subscription OnDeleteFieldTemplate {
		onDeleteFieldTemplate {
			id
			formTemplate
			inputType
			header
			tableField
			action
			rowOrder
			tableFields {
				items {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					csvKey
					identityRole
					optionsOrder
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			options {
				items {
					id
					formTemplateId
					label
					value
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			optionsOrder
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onCreateOption = /* GraphQL */ `
	subscription OnCreateOption {
		onCreateOption {
			id
			formTemplateId
			label
			value
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateOption = /* GraphQL */ `
	subscription OnUpdateOption {
		onUpdateOption {
			id
			formTemplateId
			label
			value
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteOption = /* GraphQL */ `
	subscription OnDeleteOption {
		onDeleteOption {
			id
			formTemplateId
			label
			value
			docId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;
export const onCreateFormGroup = /* GraphQL */ `
	subscription OnCreateFormGroup {
		onCreateFormGroup {
			id
			users
			name
			type
			formOrder
			formInstances {
				items {
					id
					formTemplateId
					group
					formGroup
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateFormGroup = /* GraphQL */ `
	subscription OnUpdateFormGroup {
		onUpdateFormGroup {
			id
			users
			name
			type
			formOrder
			formInstances {
				items {
					id
					formTemplateId
					group
					formGroup
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteFormGroup = /* GraphQL */ `
	subscription OnDeleteFormGroup {
		onDeleteFormGroup {
			id
			users
			name
			type
			formOrder
			formInstances {
				items {
					id
					formTemplateId
					group
					formGroup
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;
export const onCreateFormInstance = /* GraphQL */ `
	subscription OnCreateFormInstance {
		onCreateFormInstance {
			id
			formTemplateId
			formTemplate {
				id
				template
				description
				fieldsOrder
				fieldTemplates {
					nextToken
				}
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldInstances {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			formGroup
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateFormInstance = /* GraphQL */ `
	subscription OnUpdateFormInstance {
		onUpdateFormInstance {
			id
			formTemplateId
			formTemplate {
				id
				template
				description
				fieldsOrder
				fieldTemplates {
					nextToken
				}
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldInstances {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			formGroup
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteFormInstance = /* GraphQL */ `
	subscription OnDeleteFormInstance {
		onDeleteFormInstance {
			id
			formTemplateId
			formTemplate {
				id
				template
				description
				fieldsOrder
				fieldTemplates {
					nextToken
				}
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldInstances {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			formGroup
			createdAt
			updatedAt
		}
	}
`;
export const onCreateFieldInstance = /* GraphQL */ `
	subscription OnCreateFieldInstance {
		onCreateFieldInstance {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				tableField
				action
				csvKey
				identityRole
				rowOrder
				tableFields {
					nextToken
				}
				options {
					nextToken
				}
				optionsOrder
				docId
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				formInstance
				formGroup
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					csvKey
					identityRole
					optionsOrder
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				fieldTemplateId
				value
				altInstance {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				altInstanceId
				tableField
				fieldsOrder
				tableFields {
					nextToken
				}

				notes
				authors
				editing
				group
				createdAt
				updatedAt
			}
			altInstanceId
			tableField
			fieldsOrder
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}

			notes
			authors
			editing
			group
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateFieldInstance = /* GraphQL */ `
	subscription OnUpdateFieldInstance {
		onUpdateFieldInstance {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				csvKey
				identityRole
				tableField
				action
				rowOrder
				tableFields {
					nextToken
				}
				options {
					nextToken
				}
				optionsOrder
				docId
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				formInstance
				formGroup
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					csvKey
					identityRole
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				fieldTemplateId
				value
				altInstance {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				altInstanceId
				tableField
				fieldsOrder
				tableFields {
					nextToken
				}

				notes
				authors
				editing
				group
				createdAt
				updatedAt
			}
			altInstanceId
			tableField
			fieldsOrder
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}

			notes
			authors
			editing
			group
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteFieldInstance = /* GraphQL */ `
	subscription OnDeleteFieldInstance {
		onDeleteFieldInstance {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				tableField
				action
				rowOrder
				csvKey
				identityRole
				tableFields {
					nextToken
				}
				options {
					nextToken
				}
				optionsOrder
				docId
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				formInstance
				formGroup
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					tableField
					action
					rowOrder
					optionsOrder
					csvKey
					identityRole
					docId
					group
					readGroups
					createdAt
					updatedAt
				}
				fieldTemplateId
				value
				altInstance {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				altInstanceId
				tableField
				fieldsOrder
				tableFields {
					nextToken
				}

				notes
				authors
				editing
				group
				createdAt
				updatedAt
			}
			altInstanceId
			tableField
			fieldsOrder
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder

					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}

			notes
			authors
			editing
			group
			createdAt
			updatedAt
		}
	}
`;
export const onCreateAnalytics = /* GraphQL */ `
	subscription OnCreateAnalytics($username: String) {
		onCreateAnalytics(username: $username) {
			id
			userDoc
			newFormGroups
			newFormInstances
			exports
			events
			errors
			startTime
			endTime
			createdAt
			updatedAt
			username
		}
	}
`;
export const onUpdateAnalytics = /* GraphQL */ `
	subscription OnUpdateAnalytics($username: String) {
		onUpdateAnalytics(username: $username) {
			id
			userDoc
			newFormGroups
			newFormInstances
			exports
			events
			errors
			startTime
			endTime
			createdAt
			updatedAt
			username
		}
	}
`;
export const onDeleteAnalytics = /* GraphQL */ `
	subscription OnDeleteAnalytics($username: String) {
		onDeleteAnalytics(username: $username) {
			id
			userDoc
			newFormGroups
			newFormInstances
			exports
			events
			errors
			startTime
			endTime
			createdAt
			updatedAt
			username
		}
	}
`;
export const onCreateUser = /* GraphQL */ `
	subscription OnCreateUser($username: String) {
		onCreateUser(username: $username) {
			id
			username
			group
			analytics {
				items {
					id
					userDoc
					newFormGroups
					newFormInstances
					exports
					events
					errors
					startTime
					endTime
					createdAt
					updatedAt
					username
				}
				nextToken
			}
			createdAt
			updatedAt
		}
	}
`;
export const onUpdateUser = /* GraphQL */ `
	subscription OnUpdateUser($username: String) {
		onUpdateUser(username: $username) {
			id
			username
			group
			analytics {
				items {
					id
					userDoc
					newFormGroups
					newFormInstances
					exports
					events
					errors
					startTime
					endTime
					createdAt
					updatedAt
					username
				}
				nextToken
			}
			createdAt
			updatedAt
		}
	}
`;
export const onDeleteUser = /* GraphQL */ `
	subscription OnDeleteUser($username: String) {
		onDeleteUser(username: $username) {
			id
			username
			group
			analytics {
				items {
					id
					userDoc
					newFormGroups
					newFormInstances
					exports
					events
					errors
					startTime
					endTime
					createdAt
					updatedAt
					username
				}
				nextToken
			}
			createdAt
			updatedAt
		}
	}
`;
